import {
  SET_LIST_SUB_USER_DATA,
  SET_LIST_SUB_USER_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listSubUserData: null,
  listSubUserDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_SUB_USER_DATA:
      return {
        ...state,
        loading: false,
        listSubUserData: action.listSubUserData,
      };

    case SET_LIST_SUB_USER_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listSubUserDataTotal: action.listSubUserDataTotal,
      };

    default:
      return { ...state };
  }
};
